/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.identity.signPlcOperation'

export { $nsid }

/** Signs a PLC operation to update some value(s) in the requesting DID's document. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    token: l.optional(l.string()),
    rotationKeys: l.optional(l.array(l.string())),
    alsoKnownAs: l.optional(l.array(l.string())),
    verificationMethods: l.optional(l.lexMap()),
    services: l.optional(l.lexMap()),
  }),
  l.jsonPayload({ operation: l.lexMap() }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
